var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9678 4.00542C15.2798 3.70346 15.2798 3.2002 14.9678 2.91372L13.0958 1.10196C12.7998 0.799998 12.2798 0.799998 11.9678 1.10196L10.4958 2.51885L13.4958 5.42232L14.9678 4.00542ZM0.799805 11.9106V14.8141H3.7998L12.6478 6.24303L9.64781 3.33956L0.799805 11.9106Z",
    fill: "#04AAF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.67ff5e2339774e43544c7cf0e7446dcc.svg";
export { ForwardRef as ReactComponent };